(() => {
  try {
    const debug = (eventName, payload) => {};
    const EXPIRY_MS = 30 * 60 * 1000;
    const setSessionValue = (key, value) => {
      sessionStorage.setItem(key, value);
      sessionStorage.setItem(`${key}_expires`, String(Date.now() + EXPIRY_MS));
    };
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    const utmCampaign = params.get('utm_campaign');
    const campaignId = params.get('campaignid') || params.get('campaignId');
    debug('landing:params', { ref, utmCampaign, campaignId });

    if (ref !== null && utmCampaign !== null && campaignId !== null) {
      setSessionValue('ref', ref);
      setSessionValue('campaignid', campaignId);
      setSessionValue('utm_campaign', utmCampaign);
      debug('landing:session:set', { ref, utmCampaign, campaignId });
    }
  } catch (e) {
    // no-op
  }
})();
